import script from "./privacypolicy.vue?vue&type=script&setup=true&lang=js"
export * from "./privacypolicy.vue?vue&type=script&setup=true&lang=js"

import "./privacypolicy.vue?vue&type=style&index=0&id=34fd0b51&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\23586\\Desktop\\美国站\\h5\\us-station-number\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34fd0b51"]])

export default __exports__